import React, { useEffect, useState, useContext } from "react";
import { Box, Card, CircularProgress, Grid, InputAdornment, Link, Menu, TextField, Tooltip, Typography, Chip } from "@mui/material";
import MyTable from "../../components/Schedule/MyTable";
import ApiService from "../../functions/apiService";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import {  setSystemLogReducer,  setSystemLogDate,  setSystemLogDDLEmployee,  setSystemLogDDLEmployeeLogType,  setSystemLogDDLEmployeeLogSeverity,} from "../../store/systemLogReducer";
import {  ArrowDropDownIcon,  DatePicker,  LocalizationProvider,  MobileDatePicker,} from "@mui/x-date-pickers";
import { getGridStringOperators } from "@mui/x-data-grid";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment-timezone";
import Autocomplete from "@mui/material/Autocomplete";
import SystemHeaderNav from "../../components/HeadersNav/SystemHeaderNav";
import { CalendarIcon } from "../../components/Layout/Svg";
import SearchIcon from "@mui/icons-material/Search";
import PaginationComponent from "../../components/Pagination/Pagination";
import EmptyState from "../../components/Error/EmptyState";
import { toast } from 'react-toastify';
import { varFormatTime } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";

const OpenPickerIcon = () => <ArrowDropDownIcon fontSize="large" />;
const System = () => {
  const { user } = useContext(AuthContext)
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.systemLogReducer.Data);
  const date = useSelector((state) => state.systemLogReducer.Date);
  const DDLEmployee = useSelector((state) => state.systemLogReducer.DDLEmployee);
  const EmployeeLogType = useSelector((state) => state.systemLogReducer.EmployeeLogType);
  const EmployeeLogSeverity = useSelector((state) => state.systemLogReducer.EmployeeLogSeverity);
  const [loading, setLoading] = useState(true);
  const [sortMode, setSortMode] = useState(null);
  const [tableLoading, setTableLoading] = useState(true);
  const [contextMenu, setContextMenu] = useState(null);
  const [filter, setFilter] = useState({
    LogTime: moment(new Date()).format("DD-MM-YYYY"),
    LogEmpCode: "",
    LogType: "",
    LogSeverity: "",
    LogEmpText: "",
    field: "",
    type: "",
  });
  // const [dateValue, setDateValue] = useState(new Date());
  const [dateValue, setDateValue] = useState(date);
  const [changedDate, setChangedDate] = useState("");
  const [columns, setColumns] = useState([
    {
      field: "Log_Time",
      headerName: "Timestamp",
      flex: 1,
      minWidth: 160,
      hideable: false,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
			),
			renderCell: (params) => {
				let timeZone = 'America/New_York';
				let givenTimeUTC = moment.utc(params?.row?.Log_Time, 'MM/DD/YYYY HH:mm:ss');
				let timeInNY = givenTimeUTC.tz(timeZone).format('MM/DD/YYYY HH:mm:ss');
				return varFormatTime(timeInNY);
			}
    },
    {
      field: "LoggedBy",
      headerName: "Logged By",
      flex: 1,
      minWidth: 200,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
      valueGetter: (params) =>
        params.row?.log_by_emp?.employee_assignment?.EA_Rank != null
          ? params.row?.log_by_emp?.employee_assignment?.EA_Rank +
          " " +
          params.row?.log_by_emp?.fullName
          : params.row?.log_by_emp?.fullName,
    },
    {
      field: "Log_Severity",
      headerName: "Sev",
      flex: 1,
      minWidth: 60,
      filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: 'rgba(255, 165, 0, 0.26)', color: '#000000', marginTop: '18px', border: '1px solid rgba(255, 165, 0, 0.28)' }}>
          {params.value}
        </p>
      },
    },
    {
      field: "Log_Type",
      headerName: "Type",
      flex: 1,
      minWidth: 120,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
    },
    {
      field: "User",
      headerName: "User",
      flex: 1,
      minWidth: 220,
      filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
      renderCell: (params) => {
        return (
          params?.row?.log_emp &&
          <Chip
            sx={{
              height: 'auto',
              '& .MuiChip-label': {
                display: 'block',
                whiteSpace: 'normal',
              },
            }}
            style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer', backgroundColor: 'rgba(52, 152, 219, 0.16)', border: '1px solid rgba(52, 152, 219, 0.2)' }}
            label={params.row?.log_emp?.employee_assignment?.EA_Rank != null
              ? params.row?.log_emp?.employee_assignment?.EA_Rank + " " + params.row?.log_emp?.fullName : params.row?.log_emp?.fullName}
          />
        );
      },
    },
    {
      field: "Log_User_Agent",
      headerName: "Browser/Device",
      flex: 1,
      minWidth: 260,
      // sort: "asc",
      filterable: false,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.Log_User_Agent}>
            <Typography className=" text-wrap ">
              {params.row.user_agent
                ? params.row.user_agent.User_Agent_Simple
                : params.row.Log_User_Agent}
              {/* {params.row.Log_User_Agent?.substring(0, 30)} */}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "Log_Text",
      headerName: "System Message",
      flex: 1,
      minWidth: 300,
      filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
      renderCell: (params) => (
        <div style={{ padding: '10px 0px' }}>{params.value}</div>
      ),
    },
  ]);

  const loadData = (page = 1) => {
    let Query = "?page=" + page;
    for (let key in filter) {
      Query += "&" + key + "=" + filter[key];
    }
    setTableLoading(true);
    ApiService.get("/getSystemLog" + Query, {}, "getSystemLog")
      .then(({ data }) => {
        dispatch(setSystemLogReducer(data));
        setTableLoading(false);
        setLoading(false);
      })
      .catch(() => {
        setTableLoading(false);
        setLoading(false);
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
      });
    return;
  };

  useEffect(() => {
    if (DDLEmployee.length == 0) {
      ApiService.get("/getEmployeeDDL").then(({ data }) => {
        dispatch(setSystemLogDDLEmployee(data));
      });
    }
    if (EmployeeLogType.length == 0) {
      ApiService.get("/getEmployeeLogTypeDDL").then(({ data }) => {
        dispatch(setSystemLogDDLEmployeeLogType(data));
      });
    }
    if (EmployeeLogSeverity.length == 0) {
      ApiService.get("/getEmployeeLogSeverityDDL").then(({ data }) => {
        dispatch(setSystemLogDDLEmployeeLogSeverity(data));
      });
    }
    setLoading(false);
    setTableLoading(false);
    setDateValue(new Date());
  }, []);

  useEffect(() => {
    loadData(1);
  }, [filter]);

  let setPaginationModel = (e) => {
    loadData(e.page + 1);
  };

  let changeDate = (date) => {
    setChangedDate(date);
  };

  const onAccept = (date) => {
    if (date != null) {
      dispatch(setSystemLogDate(date));
      setFilter((pre) => {
        return {
          ...pre,
          LogTime: moment(date).format("DD-MM-YYYY"),
        };
      });
    } else {
      setFilter((pre) => {
        return {
          ...pre,
          LogTime: "",
        };
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key == "Enter") {
      if (!isNaN(new Date(changedDate))) {
        dispatch(setSystemLogDate(changedDate));
        setFilter((pre) => {
          return {
            ...pre,
            LogTime: moment(changedDate).format("DD-MM-YYYY"),
          };
        });
      } else {
        toast.error("Date is invalid")
        // enqueueSnackbar("Date is invalid", { variant: "error" });
      }
    }
  };

  let changeFilter = (e, value, type) => {
    if (value != null) {
      setFilter((pre) => {
        return { ...pre, [type]: value.value };
      });
    } else {
      setFilter((pre) => {
        return { ...pre, [type]: "" };
      });
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : null
    );
  };

  const rowOptions = {
    row: {
      onContextMenu: handleContextMenu,
      style: { cursor: "context-menu" },
    },
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const PageChanged = (e, page) => {
    loadData(page);
  };

  const handleSortModelChange = (value) => {
    console.log("value", value);
    setFilter((pre) => {
      return {
        ...pre,
        field: value.length == 0 ? filter.field : value[0].field,
        // type: value.length == 0 ? filter.type : value[0].sort,
        type: value.length == 0 ? [] : value[0].sort,
      };
    });
  };

  return (
    <>
      <SystemHeaderNav />
      <Card className="shadow p-3 " style={{ marginTop: "1rem" }}>
        <Typography variant="h5">View System Log</Typography>
        <Grid
          container
          spacing={2}
          columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
          className="mb-2 mt-4"
        >
          <Grid item xs={4} md={2}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                onAccept={(e) => {
                  onAccept(e);
                }}
                // format={"yyyy-MM-dd"}
                format={"MM/dd/yyyy"}
                label={"Date"}
                maxDate={new Date()}
                color={"blue"}
                value={dateValue}
                onChange={(e) => {
                  changeDate(e);
                }}
                // slots={{
                //   openPickerIcon: OpenPickerIcon,
                // }}
                slotProps={{
                  actionBar: { actions: ["clear", "today"] },
                  textField: {
                    onKeyDown: (e) => handleKeyDown(e),
                    color: "secondary",
                  },
                }}
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    padding: 0,
                    height: '48px',
                    "& .MuiButtonBase-root": {
                      marginRight: "-2px",
                      padding: "2px",
                      textAlign: "center",
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      "& svg": {
                        fontSize: "1.5rem",
                      },
                    },
                    "& .MuiInputBase-input": {
                      padding: "16px 14px",
                    },
                    "& .MuiInputAdornment-root": {
                      position: "absolute",
                      right: "9px",
                    },
                  },
                }}
                className="date-dicker"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={4} md={2}>
            <Autocomplete
              disableListWrap
              disablePortal
              onChange={(e, value) => changeFilter(e, value, "LogEmpCode")}
              options={DDLEmployee.map((item) => {
                return {
                  label:
                    item.Emp_Code +
                    " " +
                    (item.EA_Rank != null ? item.EA_Rank + " " : "") +
                    item.fullName,
                  value: item.Emp_Code,
                };
              })}
              renderInput={(params) => (
                <TextField
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: "8.5px",
                      height: '48px'
                    },
                  }}
                  {...params}
                  color={"secondary"}
                  label="Log Employee"
                />
              )}
            />
          </Grid>
          <Grid item xs={4} md={2}>
            <Autocomplete
              disableListWrap
              disablePortal
              value={`${filter.LogType}`}
              onChange={(e, value) => changeFilter(e, value, "LogType")}
              options={EmployeeLogType.map((item) => {
                return { label: item, value: item };
              })}
              // sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: "8.5px",
                      height: '48px'
                    },
                  }}
                  {...params}
                  color={"secondary"}
                  label="Log Type"
                />
              )}
            />
          </Grid>
          <Grid item xs={4} md={2}>
            <Autocomplete
              disableListWrap
              disablePortal
              value={`${filter.LogSeverity}`}
              onChange={(e, value) => changeFilter(e, value, "LogSeverity")}
              options={EmployeeLogSeverity.map((item) => {
                return { label: `${item}`, value: item };
              })}
              // sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  sx={{
                    "& .MuiInputBase-root": {
                      padding: "8.5px",
                      height: '48px'
                    },
                  }}
                  {...params}
                  color={"secondary"}
                  label="Greater than Log Severity"
                />
              )}
            />
          </Grid>
        </Grid>
        {loading && (
          <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
            <CircularProgress />
          </Box>
        )}
        {(!loading && data && data?.data?.length > 0) ? (
          <>
            <MyTable
              componentsProps={rowOptions}
              checkboxSelection={false}
              // useTopFilter
              columns={columns}
              lastPage={data.last_page}
              // rows={data.data}
              rows={data.data}
              perPage={data.per_page}
              paginationMode="server"
              rowCount={data.total}
              onPaginationModelChange={setPaginationModel}
              onePageOption={true}
              loading={tableLoading}
              hideFooter={true}
              sortType={true}
              sortMode={{
                field: filter?.field,
                sort: filter?.type,
              }}
              handleSortModelChange={handleSortModelChange}
              minHeightRow="auto"
            ></MyTable>
            <br />
            {data.data && data.data.length > 0 && (
              <PaginationComponent results={data} pageChanged={PageChanged} />
            )}
          </>
        ) : (
          <div className="mt-5">
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 460 }}>
              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
              <span className='mt-4' style={{ color: '#555555' }}>
                No Logs Found
              </span>
            </div>
          </div>
        )}
      </Card>
      <Menu
        sx={{
          ".MuiPopover-paper": {
            maxHeight: "unset",
            ".MuiList-padding": {
              paddingTop: "0px !important",
              paddingBottom: "0px !important",
            },
          },
          "& .MuiMenu-paper": {
            width: "196px",
          },
        }}
        open={contextMenu !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
        componentsProps={{
          root: {
            onContextMenu: (e) => {
              e.preventDefault();
              handleClose();
            },
          },
        }}
      >
        <div className="p-3">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
              format={"MM/dd/yyyy"}
              sx={{
                "& .MuiOutlinedInput-input": {
                  textAlign: "center",
                },
              }}
              value={dateValue}
              onChange={(e) => {
                changeDate(e);
                handleClose();
              }}
            />
          </LocalizationProvider>
          <div
            style={{
              position: "absolute",
              top: "30px",
              left: "25px",
            }}
          >
            <span
              style={{
                color: "#48535B",
                width: "17px",
                display: "block",
              }}
            >
              {" "}
              <CalendarIcon />
            </span>
          </div>
          <TextField
            placeholder="Employee"
            onChange={(e) => changeFilter(e, e.target, "LogEmpText")}
            className="my-2"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Autocomplete
            disableListWrap
            className="my-2"
            disablePortal
            value={`${filter.LogSeverity}`}
            onChange={(e, value) => changeFilter(e, value, "LogSeverity")}
            options={EmployeeLogSeverity.map((item) => {
              return { label: `${item} +`, value: item };
            })}
            // sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Sev" />}
          />
          <Autocomplete
            disableListWrap
            disablePortal
            value={`${filter.LogType}`}
            onChange={(e, value) => changeFilter(e, value, "LogType")}
            options={EmployeeLogType.map((item) => {
              return { label: item, value: item };
            })}
            // sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Type" />}
          />
        </div>
      </Menu>
    </>
  );
};

export default System;
